import { getHeaders } from '../../../core/api';
import { host } from '../../../config';

export function fetchBookings() {
  return fetch(`${host}/api/booking/request/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}
export function fetchBooking(id) {
  return fetch(`${host}/api/booking/request/${id}/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}
export function fetchBids() {
  return fetch(`${host}/api/booking/bid/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}
export function patchBid(bidId, payload) {
  return fetch(`${host}/api/booking/bid/${bidId}/`, {
    headers: getHeaders(),
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}

export function fetchSendBookingBid(bidId, payload) {
  return fetch(`${host}/api/booking/bid/${bidId}/send/`, {
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(payload),
  });
}



// WEBPACK FOOTER //
// src/routes/booking/modules/api.js